var exports = {
  "k": "x620889e6--41dd57--left",
  "p": "x620889e6--41dd57--right",
};

module.exports = exports;
